const withdraw = {
    state: {
        withdrawMax: 0,
        commissionFee: 0
    },
    mutations: {
        SET_WITHDRAW_INFO(state, withdrawInfo) {
            state.withdrawMax = Number(withdrawInfo.max_quota);
            state.commissionFee = Number(withdrawInfo.commission);
        }
    },
    actions: {
        async setWithdrawInfo({ commit }, withdrawInfo) {
            commit('SET_WITHDRAW_INFO', withdrawInfo)
        }
    }
}

export default withdraw


// WEBPACK FOOTER //
// ./src/store/modules/withdraw.js